import React from 'react'
import { type CustomEvents, Events, UserList as UserListComponent } from '../zaptic-user-list'
import { createComponent, type EventName } from '@lit-labs/react'

export const UserList = createComponent(React, 'zaptic-user-list', UserListComponent, {
    onHovered: Events.onHovered as EventName<CustomEvents[Events.onHovered]>,
    onSelected: Events.onSelected as EventName<CustomEvents[Events.onSelected]>,
})
export default UserList
